var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgForArchitects = function SvgForArchitects(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 400"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "for_architects_svg__a",
    x1: 200,
    y1: 299.65,
    x2: 200,
    y2: 103.09,
    gradientTransform: "translate(0 402) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#ad55fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a5afb"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m172.79,114.41l-80.69,139.77c-12.09,20.95,3.02,47.13,27.21,47.13h161.39c24.19,0,39.3-26.18,27.21-47.13l-80.69-139.77c-12.09-20.95-42.33-20.95-54.42,0h0Z",
    fill: "url(#for_architects_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m249.06,213.38l-.2-.08h-4.77c-1.98,4.36-4.56,8.38-7.73,12l2.15,4.48c4.52-4.8,8.08-10.31,10.56-16.4h0Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m208.81,179.41c4.63-2.93,7.73-8.07,7.73-13.94,0-8.34-6.22-15.18-14.25-16.3v-11.93h-4.56v11.93c-8.03,1.12-14.25,7.97-14.25,16.3,0,5.87,3.1,11.01,7.72,13.94l-23.75,49.83c-4.9-4.46-8.79-9.92-11.51-15.95h-4.79l-.2.08c3.15,7.74,8.15,14.65,14.48,20.13l-15.77,33.09h5.05l40.66-85.34c1.48.44,3.02.74,4.63.74s3.15-.31,4.63-.74l12.14,25.47,12.14,25.47c-1.05.79-2.12,1.53-3.22,2.22-6.57,4.16-13.96,6.64-21.76,7.27-1.3.1-2.61.16-3.93.16h-.05c-1.06,0-2.12-.04-3.18-.11-.64-.04-1.28-.12-1.92-.19-.43-.05-.85-.07-1.28-.13-.92-.12-1.83-.28-2.73-.46-.14-.03-.28-.04-.42-.07-5.21-1.05-10.23-2.95-14.83-5.65,0,0-.03,0-.04-.02l-1.96,4.12h0c3.99,2.3,8.26,4.07,12.7,5.25.06.02.11.03.17.04,1.05.28,2.11.53,3.17.74.23.05.46.07.69.12.9.17,1.8.33,2.71.45.48.06.96.09,1.44.14.67.07,1.34.15,2.02.2,1.16.08,2.32.12,3.48.12h0c2.08,0,4.15-.13,6.2-.37,2.05-.25,4.08-.61,6.09-1.1,4-.97,7.89-2.4,11.56-4.26,2.45-1.24,4.81-2.67,7.05-4.29h0l7.2,15.1,7.2,15.1h5.05l-41.55-87.19.02.03Zm-8.81-1.97c-6.6,0-11.97-5.37-11.97-11.97s5.37-11.97,11.97-11.97,11.97,5.37,11.97,11.97-5.37,11.97-11.97,11.97Z",
    fill: "#fff"
  })));
};
export default SvgForArchitects;